import { Button, Col, Form, Input, Row, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { FilterOutlined, SearchOutlined } from '@ant-design/icons';
import './FilterCommunicationsComponent.scss';
import { newStatusSelector, PageSize } from '../../../utils/constants';
import { NewsFilter } from '../../../models/CommunicationsData';

interface FilterCommunicationsComponentProps {
    onSearch: (data: NewsFilter) => void;
    searching: boolean;
}

const FilterCommunicationsComponent = (props: FilterCommunicationsComponentProps): JSX.Element => {
    const { t } = useTranslation();
    const { searching } = props;

    const [form] = Form.useForm();

    const onFinish = (values: any) => {
        props.onSearch({
            title: values.title,
            status: values.status,
            page: 0,
            pageSize: PageSize
        });
    };

    return (
        <div className="communications-filter">

            {/* ── Cabecera ───────────────────────────────────────────── */}
            <div className="filter-header">
                <span className="filter-title">
                    <FilterOutlined /> {t('components.communications.filter.buscador')}
                </span>
            </div>

            {/* ── Formulario ─────────────────────────────────────────── */}
            <Form form={form} onFinish={onFinish} layout="vertical">
                <Row gutter={16} align="bottom">
                    <Col xs={24} md={12}>
                        <Form.Item
                            name="title"
                            label={t('components.communications.filter.tittle')}
                            initialValue=""
                        >
                            <Input className="app-input" allowClear />
                        </Form.Item>
                    </Col>

                    <Col xs={24} md={8}>
                        <Form.Item
                            name="status"
                            label={t('components.communications.filter.status')}
                            initialValue=""
                        >
                            <Select className="app-input" allowClear>
                                {newStatusSelector.map((item) => (
                                    <Select.Option key={item.key} value={item.key}>
                                        {t(item.label)}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col xs={24} md={4}>
                        <Form.Item>
                            <Button
                                className="app-button search-btn"
                                htmlType="submit"
                                loading={searching}
                                disabled={searching}
                                icon={<SearchOutlined />}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </div>
    );
};

export default FilterCommunicationsComponent;
